// extracted by mini-css-extract-plugin
export default {"spacing":"PolicyDetails_spacing__Zfre+","sections":"PolicyDetails_sections__RwYKM"};